import { Injectable } from '@angular/core';
import {Title} from "@angular/platform-browser";

@Injectable({providedIn: 'root'})
export class TitleService {
  constructor(private title: Title) {
  }

  private static _title = '';
  private static _baseTitle = '';

  private updateTitle() {
    let newTitle = TitleService._title;
    if (TitleService._baseTitle.length) {
      newTitle = newTitle + ' | ' + TitleService._baseTitle;
    }
    this.title.setTitle(newTitle);
  }

  setBaseTitle(baseTitle: string) {
    TitleService._baseTitle = baseTitle;
    this.updateTitle();
  }

  getBaseTitle(): string {
    return TitleService._baseTitle;
  }

  setTitle(title: string) {
    TitleService._title = title;
    this.updateTitle();
  }

  getTitle(): string {
    return TitleService._title;
  }
}
